/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export interface QuotationDataModel {
  // id dato corrispondente al nome del field sulla tupla
  readonly id: string;
  // titolo visualizzato nella pagina
  readonly title: string;
  // formato del dato
  readonly format: 'currency' | 'perc' | 'month';
  // label tooltip
  readonly tooltip?: string;
  // rende grassetto la label
  readonly bold?: boolean;
  // valore del dato
  value?: number;
}
